import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Fuel } from '../shared/models/Fuel';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { FUEL_URL } from '../shared/constats/urls';

@Injectable({
  providedIn: 'root'
})
export class FuelService {

  constructor(private http: HttpClient, private toastrService: ToastrService,) { }

  saveFuel(fuel: Fuel): Observable<any> {
    return this.http.post(FUEL_URL + '/', fuel).pipe(
      catchError((error) => {
        this.toastrService.error('Error al guardar el tanque', 'Error');
        throw error;
      }),
      tap(() => {
        this.toastrService.success('Tanque guardado con éxito', 'Éxito');
      })
    );
  }

  editFuel(id: number, fuel: Fuel): Observable<any> {
    return this.http.put(FUEL_URL + '/' + id, fuel);
  }


  getAll(): Observable<Fuel[]> {
    return this.http.get<Fuel[]>(FUEL_URL);
  }

  getFuel(id: number): Observable<Fuel> {
    return this.http.get<Fuel>(FUEL_URL + '/' + id);
  }

  deleteFuel(id: String): Observable<any> {
    return this.http.delete(FUEL_URL + '/' + id);
  }

  getFuelByTank(tankId: number): Observable<Fuel[]> {
    return this.http.get<Fuel[]>(FUEL_URL + '/getFuelByTank/' + tankId);
  }

}
